import { MUTUAL_FUNDS_HOUESE, MUTUAL_FUNDS_HOUESE_ERROR, MUTUAL_FUNDS_HOUESE_HIDE_ERROR, } from "../interface/iMutualFundsHouses";
const initState = {
    mutualFundsHousesList: [],
    errorData: {
        error: null,
        isOpen: false,
    },
};
const mutualFundsHousesReducer = (state = initState, action) => {
    switch (action.type) {
        case MUTUAL_FUNDS_HOUESE:
            return Object.assign(Object.assign({}, state), { mutualFundsHousesList: action.payload.mutualFundsHousesList });
        case MUTUAL_FUNDS_HOUESE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case MUTUAL_FUNDS_HOUESE_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        default:
            return Object.assign({}, state);
    }
};
export default mutualFundsHousesReducer;
